import type { NavItem } from '../../../../_metronic/helpers/utils/types';

export const getInvolvedData: NavItem[] = [
  {
    label: 'Hero',
    to: '/pages/getInvolved/hero'
  },
  {
    label: 'Vision-top',
    to: '/pages/getInvolved/visionTop'
  },
  {
    label: 'Vision-bottom',
    to: '/pages/getInvolved/visionBottom'
  },
  {
    label: 'Report',
    to: '/pages/getInvolved/report'
  },
  {
    label: 'Teams',
    to: '/pages/getInvolved/teams'
  }
];
